import React from 'react';
import Status from 'Components/DesignSystem/Status/Status';
import { DRAFT, LIVE } from '../ARSConstants';

type TChipStatusProps = {
    status: boolean;
    'data-testid'?: string;
}

/**
 * Live/Draft chip for ARS models and Computed Substitutions rows — on the DS
 * `Status` since 2026-09-08. Was four inline literals (`#CFFFCE`/`#11980C` for
 * Live, `#E9E9EF`/`#5C5F62` for Draft) that could not theme; the pair maps onto
 * the two-tone doctrine exactly (`success` = live, `neutral` = draft). The prop
 * contract is unchanged; the testid is forwarded with no default (a static one
 * would duplicate the moment two rows render).
 */
const ChipStatus = ({ status, 'data-testid': dataTestId }: TChipStatusProps) => (
    <Status
        tone={status ? 'success' : 'neutral'}
        label={status ? LIVE : DRAFT}
        data-testid={dataTestId}
    />
);

export default ChipStatus;
